import { z } from 'zod';

// https://docs.slace.com/docs/stoplight-docs-core/96e9604e2ead2-contact-address
export const schemaSlaceContactAddress = z.object({
    city: z.string().optional(),
    company_name: z.string().optional(),
    country: z.string().optional(),
    country_name: z.string().optional(),
    door_number: z.string().optional(),
    house_number: z.string().optional(),
    street: z.string().optional(),
    zip: z.string().optional(),
});

export type SchemaSlaceContactAddress = z.infer<typeof schemaSlaceContactAddress>;
